<template>
  <div class="col-md-12" v-if="attributeData.type === 'text'">
    <div class="mb-7">
      <label class="fs-6 fw-bold form-label mt-3" :for="'attr-text-' + attributeData.id_medrec_attr">
            <span>
              {{ attributeData.label }} <span class="text-danger" v-if="attributeData.required">*</span>
            </span>
      </label>
      <textarea class="form-control form-control-solid" placeholder="Digite aqui..."
                :required="attributeData.required"
                :disabled="disabled"
                :ref="'attr-' + attributeData.id_medrec_attr"
                :id="'attr-text-' + attributeData.id_medrec_attr"
                :value="attributeData.text"
                rows="5"
                @input="onTextChangeHandler($event)"
                @change="saveAttributeText($event.target.value)"></textarea>
    </div>
  </div>

  <div class="col-md-12 mb-6" v-if="attributeData.type === 'html'">
    <div class="mb-7">
      <label class="fs-6 fw-bold form-label mt-3" :for="'attr-html-' + attributeData.id_medrec_attr">
            <span>
              {{ attributeData.label }} <span class="text-danger" v-if="attributeData.required">*</span>
            </span>
      </label>
      <QuillEditor
          :options="{ modules: { toolbar: [['bold', 'italic', 'image'], [{ 'list': 'ordered'}, { 'list': 'bullet' }]]  }, theme: 'snow' }"
          class="attr-html-editor"
          :style="{ minHeight: htmlEditorMinHeight + 'px' }"
          :disabled="disabled"
          :ref="'attr-' + attributeData.id_medrec_attr"
          :id="'attr-html-' + attributeData.id_medrec_attr"
          placeholder="Digite aqui..."
          :value="attributeData.text"
          @blur="onBlurHandler"
          @input="onTextChangeHandler"/>
    </div>
  </div>

  <GridInput
      v-if="attributeData.type === 'grid'"
      :attribute="attributeData"
      :disabled="disabled"
      @onChange="saveCustomAttribute"
  />

  <ImageAnnotationInput
      v-if="attributeData.type === 'image_annotation'"
      :attribute="attributeData"
      :schedule="schedule"
      :disabled="disabled"
      @onChange="saveCustomAttribute"
  />

  <StructuredListInput
      v-if="attributeData.type === 'structured_list'"
      :attribute="attributeData"
      :disabled="disabled"
      :schedule="schedule"
      @onChange="saveCustomAttribute"
  />

  <OdontogramInput
      v-if="attributeData.type === 'odontogram'"
      :attribute="attributeData"
      :schedule="schedule"
      :disabled="disabled"
      @onChange="saveCustomAttribute"
  />

  <PrenatalPanelInput
      v-if="attributeData.type === 'prenatal_panel'"
      :attribute="attributeData"
      :schedule="schedule"
      :disabled="disabled"
      @onChange="saveCustomAttribute"
  />

  <div class="col-md-6 checkbox-list" v-if="attributeData.type === 'checkbox'">
    <div class="mb-10">
      <label class="fs-6 fw-bold mb-2">
        {{ attributeData.label }} <span class="text-danger" v-if="attributeData.required">*</span>
      </label>

      <template v-for="(option, index) in attributeData.options">
        <div class="form-check form-check-custom form-check-solid mt-2">
          <input class="form-check-input" type="checkbox" :value="option.option" :required="attributeData.required"
                 @change="saveAttribute" v-model="attributeData.text" :disabled="disabled"
                 :ref="'attr-' + attributeData.id_medrec_attr"
                 :id="`check-attr-${index}-${attributeData.id_medrec_attr}`"/>
          <label class="form-check-label" :for="`check-attr-${index}-${attributeData.id_medrec_attr}`">
            {{ option.option }}
          </label>
        </div>
      </template>
    </div>
  </div>

  <div class="col-md-6" v-else-if="attributeData.type === 'number'">
    <div class="mb-10">
      <label :for="'attr-number-' + attributeData.id_medrec_attr" class="form-label">
        {{ attributeData.label }} <span class="text-danger" v-if="attributeData.required">*</span>
      </label>
      <input type="number" :id="'attr-number-' + attributeData.id_medrec_attr"
             v-model="attributeData.text" :ref="'attr-' + attributeData.id_medrec_attr"
             :required="attributeData.required" :disabled="disabled" name="checkbox"
             class="form-control form-control-solid" @change="saveAttribute">
    </div>
  </div>

  <div class="col-md-6" v-else-if="attributeData.type === 'radio'">
    <div class="mb-10">
      <label class="fs-6 fw-bold mb-2">
        {{ attributeData.label }} <span class="text-danger" v-if="attributeData.required">*</span>
      </label>
      <div class="form-check form-check-custom form-check-solid mt-2" v-for="(option, index) in attributeData.options">
        <input class="form-check-input" type="radio" :name="`option-attr-${attributeData.id_medrec_attr}`"
               :id="`option-attr-${index}-${attributeData.id_medrec_attr}`" :value="option.option"
               :ref="'attr-' + attributeData.id_medrec_attr"
               :required="attributeData.required" v-model="attributeData.text" :disabled="disabled"
               @change="saveAttribute(option)"/>
        <label class="form-check-label" :for="`option-attr-${index}-${attributeData.id_medrec_attr}`">
          {{ option.option }}
        </label>
      </div>
    </div>

    <div class="col-md-12" v-if="attributeData.option?.require_compl">
      <div class="mb-10">
        <label :for="'attr-compl-' + attributeData.id_medrec_attr" class="form-label">
          {{ attributeData.option.label }} <span class="text-danger">*</span>
        </label>
        <input type="text" :id="'attr-compl-' + attributeData.id_medrec_attr"
               v-model="attributeData.text_compl"
               :ref="'attr-' + attributeData.id_medrec_attr"
               class="form-control form-control-solid" @change="saveAttribute(null)">
      </div>
    </div>

  </div>
</template>

<script>

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import QuillEditor from "vue-quill-editor/src/editor";
import GridInput from "./GridInput.vue";
import ImageAnnotationInput from "./ImageAnnotationInput.vue";
import StructuredListInput from "./StructuredListInput.vue";
import OdontogramInput from "./OdontogramInput.vue";
import PrenatalPanelInput from "../prenatal/PrenatalPanelInput.vue";

export default {
  name: "Input",
  emits: ['onChange'],
  props: {
    attribute: Object,
    disabled: Boolean,
    schedule: {
      type: Object,
      default: null,
    },
  },
  components: {QuillEditor, GridInput, ImageAnnotationInput, StructuredListInput, OdontogramInput, PrenatalPanelInput},
  watch: {
    attribute: {
      deep: true,
      handler(newAttribute) {
        if (newAttribute?.type !== 'checkbox') {
          return;
        }

        const normalized = this.normalizeCheckboxValue(newAttribute.text);
        if (JSON.stringify(normalized) !== JSON.stringify(this.attributeData.text)) {
          this.attributeData.text = normalized;
        }
      },
    },
    'attribute.text'(newValue, oldValue) {
      if (this.attributeData.type === 'checkbox') {
        return;
      }

      if (this.skipTextWatcher || this.disabled || newValue == oldValue) {
        return;
      }

      if (this.attributeData.type === 'text' || this.attributeData.type === 'html') {
        this.syncLocalText(newValue);
      }

      this.$nextTick(() => {
        const refName = 'attr-' + this.attribute.id_medrec_attr;
        const el = this.$refs[refName];

        const inputEl = Array.isArray(el) ? el[0] : el;

        if (inputEl) {
          const evt = new Event('change', {bubbles: true});
          inputEl.dispatchEvent(evt);
        }
      });

    }
  },

  created() {
    if (this.attributeData.type === 'checkbox') {
      this.attributeData.text = this.normalizeCheckboxValue(this.attributeData.text);
    }

    if (this.attributeData.type === 'radio') {
      this.attributeData.options.forEach((option) => {
        if (option.option === this.attributeData.text) {
          this.attributeData.option = option;
        }
      });
    }
  },
  computed: {
    htmlEditorMinHeight() {
      return Math.max(120, 40 + ((Number(this.attributeData.text_rows) || 0) * 20));
    },
  },
  data() {
    return {
      attributeData: this.attribute,
      textChangeTimeout: null,
      skipTextWatcher: false,
    }
  },
  methods: {
    normalizeCheckboxValue(value) {
      if (Array.isArray(value)) {
        return value;
      }

      if (typeof value === 'string' && value.trim() !== '') {
        try {
          const parsed = JSON.parse(value);
          return Array.isArray(parsed) ? parsed : [];
        } catch (_) {
          return [];
        }
      }

      return [];
    },
    onBlurHandler(quill) {
      if (this.disabled) {
        return;
      }

      const html = quill.root.innerHTML;
      this.syncLocalText(html);
      this.saveAttributeText(html);
    },
    syncLocalText(value) {
      this.skipTextWatcher = true;
      this.attributeData.text = value;
      this.$nextTick(() => {
        this.skipTextWatcher = false;
      });
    },
    onTextChangeHandler(event) {
      if (this.disabled) {
        return;
      }

      const value = this.resolveTextInputValue(event);
      this.syncLocalText(value);

      if (this.textChangeTimeout) {
        clearTimeout(this.textChangeTimeout);
      }

      this.textChangeTimeout = setTimeout(() => {
        this.saveAttributeText(value);
      }, 1000);
    },
    resolveTextInputValue(event) {
      if (typeof event === 'string') {
        return event;
      }

      if (event?.target?.value !== undefined) {
        return event.target.value;
      }

      return '';
    },
    saveAttributeText(value) {
      if (this.disabled) {
        return;
      }

      if (value && typeof value === 'object') {
        value = this.resolveTextInputValue(value);
      }

      this.$emit('onChange', {...this.attributeData, text: value});
    },
    saveAttribute(option = null) {
      if (this.disabled) {
        return;
      }

      if ((this.attributeData.type === 'radio') && option != null) {
        this.attributeData.option = option;
      }
      this.$emit('onChange', this.attributeData);
    },
    saveCustomAttribute(attribute) {
      this.$emit('onChange', attribute);
    }
  },
  beforeDestroy() {
    // Limpa o timeout quando o componente for destruído
    if (this.textChangeTimeout) {
      clearTimeout(this.textChangeTimeout);
    }
  }
}
</script>

<style scoped>
/* O Quill põe a toolbar dentro do wrapper e dá height: 100% ao .ql-container. */
.attr-html-editor {
  display: flex;
  flex-direction: column;
}

.attr-html-editor :deep(.ql-container) {
  flex: 1 1 auto;
  height: auto;
  display: flex;
  flex-direction: column;
}

.attr-html-editor :deep(.ql-editor) {
  flex: 1 1 auto;
  height: auto;
}
</style>